module.exports = __webpack_public_path__ + "img/sld_mfm_inv_4_t1_b1_dark.485f96a7.svg";